import {
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react'
import { GiHamburgerMenu } from 'react-icons/gi'
import React from 'react'
import { Link } from 'react-router-dom'

type HamburgerMenuProps = {}

const HamburgerMenu: React.FC<HamburgerMenuProps> = () => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label='Options'
        icon={<GiHamburgerMenu size={24} />}
        variant='outline'
        w={12}
        h={12}
        _hover={{ bg: 'blue.500' }}
        _active={{ bg: 'blue.500' }}
      />
      <MenuList color='black'>
        <Link to='/'>
          <MenuItem>Tietoa</MenuItem>
        </Link>
        <Link to='/historia'>
          <MenuItem>Historia</MenuItem>
        </Link>
        <Link to='/kuvia'>
          <MenuItem>Kuvia</MenuItem>
        </Link>
        <Link to='/kalenteri'>
          <MenuItem>Kalenteri</MenuItem>
        </Link>
        <Link to='/yhteystiedot'>
          <MenuItem>Yhteystiedot</MenuItem>
        </Link>
      </MenuList>
    </Menu>
  )
}
export default HamburgerMenu
